export const ActivitesPermissions = {
  ViewandsearchinPropertyManagementActivites: {
    permissionsId: 'ea4072f9-f3f0-440c-c9d4-08d94f66fc61',
    permissionsName: 'View and search in  Property Management Activites',
    componentsId: null,
    components: null,
  },
  CreateActivity: {
    components: null,
    componentsId: null,
    permissionsId: '055207b2-9af5-427d-9336-08d967db92be',
    permissionsName: 'Create Activity'
  },
  ViewMaintenanceContract: {
    components: null,
    componentsId: null,
    permissionsId: 'ce0c2df1-a00f-4d06-9337-08d967db92be',
    permissionsName: 'view maintenance contract'
  },

  ViewActivityTypes: {
    components: null,
    componentsId: null,
    permissionsId: '6151901a-d91c-47e5-9338-08d967db92be',
    permissionsName: 'view activity types'
  },
  ViewLeads: {
    components: null,
    componentsId: null,
    permissionsId: '37fffb76-3f8f-4d02-9339-08d967db92be',
    permissionsName: 'view Leads'

  },
  ViewUnits: {
    components: null,
    componentsId: null,
    permissionsId: 'aebf3edc-8a13-4717-933a-08d967db92be',
    permissionsName: 'view units'
  },

  ViewWorkOrders: {
    components: null,
    componentsId: null,
    permissionsId: '6366f955-6cd7-498b-933b-08d967db92be',
    permissionsName: 'view work order'
  },

  ViewPortfolios: {
    components: null,
    componentsId: null,
    permissionsId: '20107b79-9522-43f0-933c-08d967db92be',
    permissionsName: 'view Portfolios'
  },
  EditActivity:
  {
    permissionsId: 'd4bb9d79-090a-4c45-0d78-08d96c602a6b',
    permissionsName: 'Edit Activity',
    componentsId: null,
    components: null
  }

};
